module.exports = __webpack_public_path__ + "zvetseni-prsou_68_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_68_after.jpg
// module id = 1363
// module chunks = 0